import React, { useState } from 'react';
import { useAuth } from '../auth';
import Logo from './Logo';
import { APP_VERSION } from '../version';

export default function MobileLogin() {
  const { login } = useAuth();
  const [u, setU] = useState('');
  const [p, setP] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!u || !p) return;
    setBusy(true); setErr('');
    try {
      await login(u.trim(), p);
    } catch (ex) {
      setErr(ex.response?.data?.detail || 'Credenziali non valide');
      setBusy(false);
    }
  };

  return (
    <div className="m-login">
      <Logo size={64} />
      <div style={{ textAlign: 'center' }}>
        <h1>Sistema</h1>
        <p>Accedi per controllare gli agenti</p>
      </div>
      <form onSubmit={submit}>
        <input value={u} onChange={(e) => setU(e.target.value)} placeholder="Utente"
          autoCapitalize="none" autoCorrect="off" autoComplete="username" disabled={busy} />
        <input value={p} onChange={(e) => setP(e.target.value)} placeholder="Password"
          type="password" autoComplete="current-password" disabled={busy} />
        {err && <div className="err">{err}</div>}
        <button className="m-btn start" type="submit" disabled={busy}>
          {busy ? 'Accesso…' : 'Entra'}
        </button>
        <div style={{ textAlign: 'center', marginTop: 16, fontSize: 11, opacity: .6 }}>versione {APP_VERSION}</div>
      </form>
    </div>
  );
}
